import { FC, useEffect, useState } from 'react'
import * as Yup from 'yup'
import { ErrorMessage, Field, FieldArray, Form, Formik, FormikErrors } from 'formik'
import { API_IMG_AVATR, Adapter, CommonService, IFormJobAssess, Pattern, SeasonDto, JobService, JobRequestDto, Helper, JobDto, KPISummaryService, KPIStatus, KpiSummaryDto, SystemDateLongDisplay, SystemDateSaveFormat } from '../../modules/core'
import { catchErrorMsg, timeToString } from '../../modules/core/helpers/Helper'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { FormDataPicker, FormInputNumber, FormRadio } from 'app/components'
import { PageTitle } from '_metronic/layout/core'
import { RootState } from 'setup'
import { shallowEqual, useSelector } from 'react-redux'
import moment from 'moment'
import { FormUpload } from 'app/components/formInputs/FormUpload'
import { RCTimePicker } from 'app/components/date-picker/RCTimePicker'
import _ from 'lodash'

type Props = {

}

let initValue: IFormJobAssess = {
    seasonId: 0,
    assessTypeId: 2,
    title: '',
    point: 5,
    recordDate: new Date(),
    jobCategory: 'SVNH',
    startTime: new Date().setMinutes(0),
    endTime: new Date().setMinutes(0),
    totalHr: 0,
    startTimeStr: moment(new Date()).format('HH:mm'),
    endTimeStr: moment(new Date()).format('HH:mm'),
    testStartTime:'',
    testEndTime:''
}

const formSchema = Yup.object().shape({
    title: Yup.string().required('require'),
    recordDate: Yup.date().required('require'),
    //point: Yup.number().min(1, 'more than zero').required('require'),
})



export const JobDetailPage: FC<Props> = () => {

    const lastSeason = useSelector<RootState>(({ core }) => core.lastSeason, shallowEqual) as SeasonDto
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState<IFormJobAssess>(initValue)
    const [disabledHourS, setDisabledHourS] = useState<number[]>([])
    const [disabledHourE, setDisabledHourE] = useState<number[]>([])


    const { id } = useParams()
    const navigate = useNavigate()
    useEffect(() => {
        const init = () => {

            if (id && id !== 'new') {
                JobService.GetById(parseInt(id)).then((result) => {
                    const res = result.data.result
                    if (res) {
                        const frmDto = Adapter.FormJobAssess(res);
                        console.log(frmDto.startTime,moment(frmDto.startTime).format(SystemDateLongDisplay))
                        setData(frmDto)
                    }
                })
            }
            setLoading(false)
        }
        init()
    }, [id])


    const onSubmit = async (values: IFormJobAssess) => {

        setLoading(true)

        if (!lastSeason?.id) {
            toast.error('season โหลดไม่ถูกต้อง')
            setLoading(false)
            return
        }
        const updatedData = Adapter.mapJobAsess(values)
       
        const diff = moment.duration(values.endTime - values.startTime)
        updatedData.totalHr = diff.hours() + (diff.minutes() === 30 ? 0.5 : 0)
        updatedData.seasonId = lastSeason?.id
    
        if (id === 'new') {
            Save(updatedData)
        } else if (id) {
            Update(parseInt(id), updatedData)
        }


    }

    const Save = (updatedData: JobRequestDto) => {
        JobService.Create(updatedData)
        .then((res) => {
            toast.success('Save Success.')
            setLoading(false)
            navigate('/Job')
        }).catch((res) => {
            
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }

    const Update = (id: number, updatedData: JobRequestDto) => {
        JobService.Update(id, updatedData).then(() => {
            toast.success('Update Success.')
            setLoading(false)
            navigate('/Job')
        }).catch((res) => {
            toast.error(catchErrorMsg(res))
            setLoading(false)
        })
    }


    const CellStyle: React.FC<{ lable: string, children?: React.ReactNode, labelCls?: string, inputCls?: string }> = (props) => {
        const labelCls = props.labelCls ?? 'col-lg-4 fw-bold'
        const inputCls = props.inputCls ?? 'col-lg-4'
        return (
            <div className='row mb-7'>
                <label className={labelCls}>{props.lable}</label>

                <div className={inputCls}>
                    <span className='fw-bolder fs-6 text-dark'>{props.children}</span>
                </div>
            </div>
        )
    }



    let minDate: Date | undefined = undefined;
    let maxDate: Date | undefined = undefined;
    if (lastSeason) {
        minDate = new Date(lastSeason.periodStart)
        const t_maxDate = new Date(lastSeason.periodEnd)
        maxDate = new Date(t_maxDate.getFullYear(), t_maxDate.getMonth() + 1, 0)
    }


    return (
        <>
        
            <PageTitle
                breadcrumbs={[
                    {
                        title: 'ประเมินตนเอง',
                        path: '/selfAssess',
                        isSeparator: false,
                        isActive: false,
                    },
                ]}
            >
                คะแนนพิเศษ
            </PageTitle>
            <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                    <div className='card-title m-0 '>
                        <h3 className='fw-bolder py-2'>{lastSeason?.title}</h3>
                        <h3 className='fw-bolder ps-5'>{lastSeason ? `${moment(lastSeason.periodStart).format("YYYY MMM")} - ${moment(lastSeason.periodEnd).format("YYYY MMM")}` : ""}</h3>
                    </div>
                </div>
                <Formik
                    enableReinitialize
                    initialValues={data}
                    validationSchema={formSchema}
                    onSubmit={onSubmit}
                 //validate={(v) => console.log(v)}
                >
                    {({ values, handleSubmit, setFieldValue, errors, touched }) => (
                        <Form>
                            <>
                                {/* begin::Scroll */}
                                <div className='card-body p-9'>
                                    {/* {JSON.stringify(values)} */}
                                    <CellStyle lable='วันที่'>
                                        <Field
                                            as='text'
                                            name='recordDate'
                                            className={
                                                'form-control form-control-solid' +
                                                (errors.recordDate && touched.recordDate ? ' is-invalid' : '')
                                            }
                                            value={moment(values.recordDate).format('DD/MM/YYYY')}
                                            onDateChange={(value: Date, e: any) => {
                                                setFieldValue('recordDate', value)
                                            }}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            component={FormDataPicker}
                                        />
                                        {/* <ReactCalendar/> */}
                                        <ErrorMessage name={`recordDate`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='เวลาเริ่ม' inputCls='col-lg-2'>
                                        <RCTimePicker
                                            name='startTime'
                                            value={moment(values.startTime)}
                                            minuteStep={30}
                                            disabledHours={() => disabledHourS}
                                            onChange={(e: any) => {
                                                //setFieldValue('testStartTime', `${moment(e?.valueOf())}-${moment(e?.valueOf()).valueOf()}`)
                                                setFieldValue('startTime', e?.valueOf() ?? new Date().setMinutes(0))
                                                setFieldValue('startTimeStr',e?.format('HH:mm') ?? '00:00')
                                            }}
                                        />
                                
                                        <ErrorMessage name={`startTime`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='เวลาจบ' inputCls='col-lg-2'>
                                        <RCTimePicker
                                            name='endTime'
                                            value={moment(values.endTime)}
                                            minuteStep={30}
                                            disabledHours={() => disabledHourE}
                                            onChange={(e: any) => {
                                             
                                                //setFieldValue('testEndTime', `${moment(e?.valueOf())}-${moment(e?.valueOf()).valueOf()}`)
                                                setFieldValue('endTime', e?.valueOf() ?? new Date().setMinutes(0))
                                                setFieldValue('endTimeStr',e?.format('HH:mm') ?? '00:00')
                                            }}
                                        />
                                        
                                        <ErrorMessage name={`endTime`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='จำนวน ชม.' inputCls='col-lg-2'>
                                        {
                                            //moment(new Date().setTime(values.endTime-values.startTime)).format('HH:mm')
                                            //`${Math.floor((values.endTime-values.startTime)/3600000)} H ${Math.floor((values.endTime-values.startTime)/60000)}`                                                                                        
                                            Helper.totalTime(values.endTime - values.startTime)
                                        }
                                    </CellStyle>

                                    <CellStyle lable='รายละเอียด'>
                                        <Field
                                            as='textarea'
                                            autoComplete='off'
                                            name='title'
                                            className={
                                                'form-control form-control-lg form-control-solid mb-3 mb-lg-0' +
                                                (errors.title && touched.title ? ' is-invalid' : '')
                                            }
                                            rows={3}
                                        />
                                        <ErrorMessage name={`title`} component='div' className='text-danger' />
                                    </CellStyle>
                                    <CellStyle lable='ลักษณะงาน'>
                                        <div className='d-flex justify-content-between'>
                                            <Field
                                                label={'SVNH'}
                                                name={`jobCategory`}
                                                gName={`jobCategory`}
                                                gValue={'SVNH'}
                                                component={FormRadio}

                                            />
                                            <Field
                                                label={'Training'}
                                                name={`jobCategory`}
                                                gName={`jobCategory`}
                                                gValue={'Training'}
                                                component={FormRadio}

                                            />
                                            <Field
                                                label={'Holistic'}
                                                name={`jobCategory`}
                                                gName={`jobCategory`}
                                                gValue={'Holistic'}
                                                component={FormRadio}

                                            />
                                        </div>

                                    </CellStyle>

                                </div>
                                {/* end::Scroll */}

                                <div className='card-footer d-flex py-6 px-9'>
                                    <button type='submit' className='btn btn-primary pe-5  me-10' disabled={loading}>
                                        {!loading && 'Save Changes'}
                                        {loading && (
                                            <span className='indicator-progress' style={{ display: 'block' }}>
                                                Please wait...
                                                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                        )}
                                    </button>

                                    <button className='btn btn-light' onClick={() => navigate('/Job')}> Back</button>
                                </div>
                            </>
                        </Form>
                    )}
                </Formik>
                
            </div>
        </>
    )
}

